export default {
  mounted(el, binding) {
    el._bindClickHandler = createClickHandler(binding)
    el.addEventListener('click', el._bindClickHandler)
  },
  updated(el, binding) {
    el.removeEventListener('click', el._bindClickHandler)
    el._bindClickHandler = createClickHandler(binding)
    el.addEventListener('click', el._bindClickHandler)
  },
  unmounted(el) {
    if (el._bindClickHandler) {
      el.removeEventListener('click', el._bindClickHandler)
      delete el._bindClickHandler
    }
  }
}

function createClickHandler(binding) {
  const { isUserLoggedIn } = storeToRefs(useUserStore())
  const { setRedirectUrl, openLoginHint } = useLoginHint()
  const $router = useRouter()

  return async (event) => {
    event.preventDefault()
    const action = binding.value

    if (!isUserLoggedIn.value) {
      setRedirectUrl(typeof action === 'string' ? action : null)
      openLoginHint()
    } else {
      if (typeof action === 'function')
        await action()
      else if (typeof action === 'string')
        $router.push(action)
    }
  }
}
